import { createListFilters, IOption } from '../../../../../components'

export type PegaPlantaoFilters = {
  local?: IOption<string>
  /** Depende do local (é limpo quando o local muda). A agenda só carrega com local e setor. */
  setor?: IOption<string>
  tipoPlantao?: IOption<string>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<PegaPlantaoFilters>({
  local: undefined,
  setor: undefined,
  tipoPlantao: undefined,
})
